import { createWebHistory, createRouter } from 'vue-router'
import AboutView from '../components/AboutView.vue'
import HelloView from '../components/HelloView.vue'
import HomeView from '../components/HomeView.vue'
import BillingView from '../components/BillingView.vue'
import TermsView from '../components/TermsView.vue'
import PrivacyView from '../components/PrivacyView.vue'
// import CallBack from '../components/CallBack.vue'
// import ServerError from '../components/ServerError.vue'
import ClusterView from '../components/ClusterView.vue'
import DevTools from '../components/DevTools.vue'
import { client } from '../main';
import GetClientAuthStatusQuery from '../graphql/user/GetClientAuthStatusQuery.gql';

const routes = [
	{
		path: '/about',
		name: 'About',
		component: AboutView,
		meta: { requiresAuth: true }
	},
		{
		path: '/welcome',
		name: 'Welcome',
		component: HelloView,
	},
	{
		path: '/',
		name: 'Home',
		component: HomeView,
	},
		{
		path: '/terms',
		name: 'Terms',
		component: TermsView,
	},
	{
		path: '/privacy',
		name: 'Privacy',
		component: PrivacyView,
		meta: { requiresAuth: true }
	},
	{
		path: '/billing',
		name: 'Billing',
		component: BillingView,
		meta: { requiresAuth: true }
	},
	{
		path: '/cluster',
		name: 'Cluster',
		component: ClusterView,
		meta: { requiresAuth: true }
	},
	{
		path: '/devtools',
		name: 'DevTools',
		component: DevTools,
		meta: { requiresAuth: true }
	},
		{
		path: '/login',
		redirect: { name: 'Home' }
	}
]
const router = createRouter({
	history: createWebHistory(),
	routes,
})

router.beforeEach(async (to, from, next) => {
	let auth;
	try {
		const res = client.readQuery({ query: GetClientAuthStatusQuery });
		auth = res?.authStatus;
	} catch (e) {
		auth = { isAuthenticated: false };
	}

	const requiresAuth = to.matched.some(record => record.meta.requiresAuth);

	// If cache says false, check local storage for our JWT token instead of Amplify
	if (!auth?.isAuthenticated) {
		const token = localStorage.getItem('user-token') || sessionStorage.getItem('user-token');
		if (token) {
			// We have a token! Treat as authenticated for routing purposes
			auth = { isAuthenticated: true };
		} else {
			if (requiresAuth) return next({ name: 'Home' });
		}
	}
	
	if (to.name === 'Home' && auth?.isAuthenticated) {
		// If user is authenticated and trying to access home page,
		// always redirect to cluster page
		return next({ name: 'Cluster' });
	}


	// if (to.name === 'Home' && auth?.isAuthenticated) {
	// 	return next({ name: 'Cluster' });
	// }

	next();
});

export default router;

